export const GET_SITE_SETTING_BEGIN = "GET_SITE_SETTING_BEGIN";
export const GET_SITE_SETTING_SUCCESS = "GET_SITE_SETTING_SUCCESS";
export const GET_SITE_SETTING_ERROR = "GET_SITE_SETTING_ERROR";
